import LinearProgress from '@mui/material/LinearProgress';
import React from 'react';
import { AppContext } from '../../contexts/app-context';
import { AuthContext } from '../../contexts/auth-context';
import { usePermissions } from '../../hooks/use-permissions';
import { AWS_GROUP } from '../../types';

const Components = {
  AdminBar: React.lazy(() => import('./admin-bar')),
  AgentBar: React.lazy(() => import('./agent-bar')),
};

export function Arrival() {
  // Context
  const {
    state: { arrival },
  } = React.useContext(AppContext);
  const authContext = React.useContext(AuthContext);
  // Hooks
  const { checkPermissions } = usePermissions();

  const isAdmin = checkPermissions([
    AWS_GROUP.AllianceEvents_Admin,
    AWS_GROUP.AllianceEvents_CheckIn,
  ]);
  const isAuthenticated = authContext.state.user !== undefined;

  if (arrival.events.length && isAdmin) {
    return (
      <React.Suspense fallback={<LinearProgress color="primary" />}>
        <Components.AdminBar data={arrival.events} />
      </React.Suspense>
    );
  } else if (arrival.events.length && isAuthenticated) {
    return (
      <React.Suspense fallback={<LinearProgress color="primary" />}>
        <Components.AgentBar data={arrival.events} />
      </React.Suspense>
    );
  } else {
    return null;
  }
}
